module.exports = "../../../../platform/assets/pageMainIcon/business_yewushezhilei1.svg";